import { Navigate, useLocation } from "react-router-dom";
import { RolesEnum } from "../types/route.types";
import { PermissionType } from "../types/user.types";
import { all_routes } from "./all_routes";

interface ProtectedRouteProps {
  element: React.ReactNode;
  allowedRoles: PermissionType[];
  userRole?: PermissionType[];
  sub?: any; // Sub bilgisi
  user?: any; // User bilgisi (SuperAdmin kontrolü için)
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  allowedRoles,
  userRole,
  sub,
  user
}) => {
  const location = useLocation();
  
  // ⚠️ CRITICAL: Abonelik durumu kontrolü
  const isSubscriptionExpired = sub?.status === 'expired' || sub?.status === 'inactive';
  const isSuperAdmin = user?.role === RolesEnum.SUPERADMIN;
  
  // SuperAdmin'ler abonelik kontrolünden muaf
  if (isSuperAdmin) {
    // SuperAdmin için normal yetki kontrolü yap
    const hasPermission = allowedRoles.some(role => userRole?.includes(role));
    if (hasPermission) {
      return <>{element}</>;
    }
    // SuperAdmin'in yetkisi yoksa SuperAdmin dashboard'a yönlendir
    return <Navigate to={all_routes.superAdminDashboard2} replace />;
  }
  
  // Eğer abonelik bittiyse (SuperAdmin hariç)
  if (isSubscriptionExpired) {
    // Callback sayfası için özel exception - ödeme sonrası erişim gerekli
    const isCallbackPage = location.pathname === all_routes.subscriptionCallback;
    
    
    
    // PRICING_ACCESS yetkisi olanlar pricing sayfasına erişebilir
    // COMPANY yetkisi olanlar callback sayfasına erişebilir (ödeme sonrası için)
    if (allowedRoles.includes(PermissionType.PRICING_ACCESS) || 
        (isCallbackPage && allowedRoles.includes(PermissionType.COMPANY))) {
      return <>{element}</>;
    }
    // Diğer tüm sayfalar için pricing'e yönlendir
    return <Navigate to={all_routes.pricing} replace />;
  }
  
  // Kullanıcının hiç yetkisi yoksa ana sayfaya yönlendir
  if (!userRole || userRole.length === 0) {
    return <Navigate to="/" replace />;
  }

  // Normal yetki kontrolü - kullanıcının en az bir gerekli yetkiye sahip olması gerekir
  const hasPermission = allowedRoles.some(role => userRole.includes(role));
  
  if (!hasPermission) {
    // USER rolü için control_panel_user yetkisi varsa, ticket sayfasına yönlendir
    if (userRole.includes(PermissionType.CONTROL_PANEL_USER)) {
      return <Navigate to={all_routes.ticketEmployee} replace />;
    }
    // ADMIN rolü için control_panel_admin yetkisi varsa, admin dashboard'a yönlendir
    else if (userRole.includes(PermissionType.CONTROL_PANEL_ADMIN)) {
      return <Navigate to={all_routes.adminDashboard} replace />;
    }
    // Diğer durumlar için ana sayfaya yönlendir
    return <Navigate to="/" replace />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;